export default {

    title: `Flax: Fibre of the future`,

    subTitle: `Sustainable goals`,

    author: `By Élodie Epaillard, journalist.`,

    content1: `<strong>Fueled by renewed consumer interest</strong> for natural materials, the flax market is flourishing. And this is just the beginning: a series of experiments are revealing the plant fibre to be an inexhaustible source of sustainable innovation.`,

    content2: `In addition to being an environmentally friendly crop, requiring neither pesticides nor irrigation during its cultivation, <strong>flax is an ideal response to resource sovereignty issues</strong> especially given that France is its leading producer globally. France has already begun in-shoring the sector with the opening of three spinning mills between 2020 and 2022 and a fourth due by the end of this year. The approach is giving ideas to neighbouring exporter nations, Belgium and the Netherlands. Across the Old Continent, which produces 80% of the world’s flax harvest, start-ups and manufacturers are increasingly interested in this <strong>recyclable material</strong> with its remarkable properties.`,

    content3: `If until now, flax was mainly used in the textile sector, its technical applications are increasingly seeing the inflow of research & development investment, with the goal of replacing carbon or plastic in particular. Light, strong and endowed with vibration-absorbing and insulating qualities, flax is suitable for the manufacture of furniture, fishing rods, skis, kayaks, bicycle frames and even window frames.`,

    title4: `The initiatives`,
    content4: `Convinced of the potential of this age-old fibre, the Normandy based company Eco-Technilin has developed a series of innovative products, including parts intended for car interiors, sailor Roland Jourdain’s sailboat and Carlos Alcaraz’s tennis racket. In Amsterdam, it even participated in the construction of the first bridge in the world made from flax.`,

    content5: `Flax is also proving inspirational across the Channel. The University of Nottingham has created prototype wind turbine blades using woven flax. On a more down-to-earth note, Scottish researchers recently developed a sustainable alternative to palm oil from a by-product of the flaxseed and rapeseed oil industries.`,

    content6: `The European Space Agency (ESA) is also studying the possibility of reinforcing satellite solar-panels with flax. Capable of withstanding extreme temperature variations, the fibre would make it possible to exchange radio transmissions while limiting signal loss. Above all, as flax is biodegradable, it would be completely burned up during re-entry into the earth’s atmosphere once the satellite reaches the end of its life. An important factor at a time when the amount of space debris is increasingly worrying.`,


    // KEY FIGURES
    keyFigures: [
        {
            figure: 3.7,
            figureDecimals: 1,
            suffix: `tonnes of CO<sub>2</sub>`,
            content: `One hectare of flax absorbs 3.7 tonnes of CO2 every year. This is called a carbon sink.`,
            source: `Source : The know-how of textile flax, Ministry of Culture 2021.`,
            topImage: `Sustainable_001.svg`,
            noCollapse: true,
        },
        {
            figure: '5 to 10',
            suffix: `times less`,
            content: `The production of flax is 5 to 10 times less energy-intensive than that of fibreglass.`,
            source: `Source : <a href="www.sciencesetavenir.fr" target="_blank">www.sciencesetavenir.fr</a>`,
            topImage: `Sustainable_002.svg`,
            noCollapse: true,
        },
    ],

}
